import { AsyncThunk } from '@reduxjs/toolkit'
import { Avatar, Button, Flex, Form, List, message } from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { useEffect, useState } from 'react'
import { HiMiniNoSymbol } from 'react-icons/hi2'
import { MdEdit } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router-dom'
import { EditFolderDTO, PlaylistFolder } from '../../utils/redux/moodsSlice'
import {
  attemptGetPlaylistsList,
  Playlist,
  PlaylistOrderBy
} from '../../utils/redux/playlistsSlice'
import { listenerMiddleware, useAppDispatch } from '../../utils/redux/store'
import PlaylistFolderForm from '../PlaylistFolderForm/PlaylistFolderForm'
import { NewFolderProps } from './NewFolder'
interface Params extends Record<string, string> {
  id: string
}

type Props = Omit<NewFolderProps, 'attempt'> & {
  folder: 'mood' | 'business' | 'daytime' | 'style'
  attemptGet: AsyncThunk<PlaylistFolder, string, AsyncThunkConfig>
  // attemptGetPayload?: Omit<GetListPlaylistsDto, keyof GetListDTO>
  attemptEdit: AsyncThunk<void, EditFolderDTO, AsyncThunkConfig>
}
export default function EditFolder({
  attemptGet,
  attemptEdit,
  uploadedDestination,
  successPath,
  folder,
}: Props) {
  const { id } = useParams<Params>()

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    async function getFolder() {
      const { /* playlists, */ title, image } = await dispatch(
        attemptGet(id || 'undefined'),
      ).unwrap()
      editFolderForm.setFieldsValue({
        title,
        /* playlists: playlists.map(playlist => playlist._id), */ image,
      })
    }
    getFolder()
  }, [])

  const isUpdating = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptEdit,
    onFulfilled: () => {
      message.success('Folder has been successfully updated!')
      navigate(successPath)
    },
  })

  const isLoading = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptGet,
  })

  function onFinish(values: EditFolderDTO) {
    dispatch(attemptEdit({ ...values, _id: id || 'undefined' }))
  }

  const [playlists, setPlaylists] = useState<Playlist[]>([])
  useEffect(() => {
    async function getPlaylists() {
      const playlists = await dispatch(
        attemptGetPlaylistsList({
          skip: 0,
          limit: 200,
          oderBy: PlaylistOrderBy.TITLE,
          [folder]: id,
        }),
      ).unwrap()
      setPlaylists(playlists.playlists)
    }
    getPlaylists()
  }, [])

  const [editFolderForm] = Form.useForm<EditFolderDTO>()

  return (
    <div className="content">
      <PlaylistFolderForm
        onFinish={onFinish}
        isLoading={isLoading || isUpdating}
        form={editFolderForm}
        uploadedDestination={uploadedDestination}
        playlistTable={
          <List
            bordered
            dataSource={playlists}
            renderItem={(playlist) => {
              return (
                <List.Item
                  actions={[
                    <Button
                      onClick={() => {
                        navigate(`/music/playlists/playlist-edit/${playlist._id}`)
                      }}
                      icon={<MdEdit />}
                    />,
                    // <Button
                    //   onClick={() => {
                    //     Modal.confirm({
                    //       width: 'auto',
                    //       onOk: () =>
                    //         dispatch(
                    //           attemptEditPlaylist({
                    //             ...playlist,
                    //             songs: playlist.songs.map((song) => song._id),
                    //             [folder]: undefined,
                    //           }),
                    //         ),
                    //       ...confirm,
                    //     })
                    //   }}
                    //   icon={<MdDelete />}
                    // />,
                  
                  ]}
                >
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        shape="square"
                        src={`${process.env.REACT_APP_PLAYLISTS_BASE_URL}/${playlist.image}`}
                        icon={<HiMiniNoSymbol />}
                      />
                    }
                    title={<Flex align="center">{playlist.title}</Flex>}
                  />
                </List.Item>
              )
            }}
          />
        }
      />
    </div>
  )
}
